import { useThumbnail } from '@/hooks/useThumbnail';
import { IThumbnailProps } from '@/types/attachment';
import { Image, ImageProps, Spinner } from '@chakra-ui/react';

interface ThumbnailComponentProps extends Omit<ImageProps, 'src'>, IThumbnailProps {
  showLoading?: boolean;
}

export const Thumbnail: React.FC<ThumbnailComponentProps> = ({
  thumbnailPath,
  fallbackPath = '/images/noImage.png',
  alt = 'Thumbnail',
  showLoading = false,
  ...imageProps
}) => {
  const { src, loading } = useThumbnail(thumbnailPath, fallbackPath);

  if (showLoading && loading) {
    return <Spinner size="sm" color="blue.500" />;
  }

  return (
    <Image
      src={src}
      alt={alt}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.src = fallbackPath;
      }}
      {...imageProps}
    />
  );
};
